<script setup lang="ts">
import { ref, type PropType } from 'vue';
import Select from 'primevue/select';
import { type Timezone, getTimezones, getCurrentTimezone } from '@/components';

const props = defineProps({
  timezone: {
    type: Object as PropType<Timezone>,
    default: getCurrentTimezone()
  }
});
const selectedTimezone = ref(props.timezone);

const timezones = ref(getTimezones());

const emits = defineEmits(['update:timezone', 'onChange']);
const onChange = () => {
  emits('update:timezone', selectedTimezone.value);
  emits('onChange', selectedTimezone.value);
};
</script>

<template>
    <div class="timezone-selector">
        <Select v-model="selectedTimezone"
          class="every-select"
          @change="onChange"
          optionLabel="label"
          :options="timezones"/>
    </div>
</template>
